<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="/img/brand/logo-tamasia-full.png" width="89" height="32" alt="Tamasia Logo">
        <img class="navbar-brand-minimized" src="/img/brand/logo-tamasia-small.png" width="32" height="32" alt="Tamasia Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />

      <b-navbar-nav class="ml-auto">
        <HeaderDropdownAccount/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarNav :nav-items="nav"/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <b-alert :show="storeState.showAlert" :variant="storeState.alertVariant">
            {{ storeState.alertMsg }}
          </b-alert>
        </div>
        <div :class="{ 'd-none': storeState.isInitLoading }" class="container-fluid">
          <router-view/>
        </div>
        <div :class="{ 'show-loader': storeState.isInitLoading }" class="init-loader"><i class="fa fa-spinner fa-spin" /></div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://coreui.io">CoreUI</a>
        <span class="ml-1">&copy; 2018 creativeLabs.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI</a>
      </div>
    </TheFooter>
    <div :class="{ 'show-loader': storeState.isChildLoading }" class="child-loader"><i class="fa fa-spinner fa-spin" /> Loading</div>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarNav, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import HeaderDropdownAccount from './HeaderDropdownAccount'
import { store } from '@/shared/store'

export default {
  name: 'AppContainer',
  components: {
    AppHeader,
    AppSidebar,
    TheFooter,
    Breadcrumb,
    HeaderDropdownAccount,
    SidebarToggler,
    SidebarNav,
  },
  data () {
    return {
      nav: nav.items,
      storeState: store.state,
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
}
</script>
